export const getStartOfUTCDay = (timestamp: number) => new Date(timestamp).setUTCHours(0, 0, 0, 0);

export const getTrialDaysLeft = (currentDate: number, trialEndTime?: number): number | undefined =>
	trialEndTime && Math.ceil((getStartOfUTCDay(trialEndTime) - currentDate) / (24 * 3600 * 1000));
